import React from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import ReadyToBuild from '../ReadyToBuild';
import FeedbackSection from '../../ArticleFooter/FeedbackSection';
import styles from './styles.module.styl';

const MicrositeTemplate = ({ contentReady, renderContent, doc }) => (
  <React.Fragment>
    <div className={styles.headerContainer}>
      <Header {...doc.meta} />
    </div>

    {doc.meta.ctaLink && <ReadyToBuild {...doc.meta} position="top" />}

    <div className={styles.micrositeContainer}>
      {contentReady && renderContent(doc)}

      <hr />

      <div className={styles.feedbackSection} >
        <FeedbackSection
          articleUrl={doc.url}
          githubEditLink={doc.meta.editUrl}
        />
      </div>
    </div>

    {doc.meta.ctaLink && <ReadyToBuild {...doc.meta} position="bottom" />}
  </React.Fragment>
);

MicrositeTemplate.propTypes = {
  contentReady: PropTypes.bool.isRequired,
  renderContent: PropTypes.func.isRequired,
  doc: PropTypes.object
};

MicrositeTemplate.defaultProps = {
  contentReady: false,
  renderContent: () => {},
  doc: {
    meta: {}
  }
};

export default MicrositeTemplate;
